var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 6.66699C14.1421 6.66699 17.5 5.5477 17.5 4.16699C17.5 2.78628 14.1421 1.66699 10 1.66699C5.85786 1.66699 2.5 2.78628 2.5 4.16699C2.5 5.5477 5.85786 6.66699 10 6.66699Z",
    stroke: "#DBEAFE",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.5 4.16699V15.8337C2.5 16.4967 3.29018 17.1326 4.6967 17.6014C6.10322 18.0703 8.01088 18.3337 10 18.3337C11.9891 18.3337 13.8968 18.0703 15.3033 17.6014C16.7098 17.1326 17.5 16.4967 17.5 15.8337V4.16699",
    stroke: "#DBEAFE",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.5 10C2.5 10.663 3.29018 11.2989 4.6967 11.7678C6.10322 12.2366 8.01088 12.5 10 12.5C11.9891 12.5 13.8968 12.2366 15.3033 11.7678C16.7098 11.2989 17.5 10.663 17.5 10",
    stroke: "#DBEAFE",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogsIcon);
export default __webpack_public_path__ + "static/media/logs-icon.21dc114139135c937893876ab79c10e6.svg";
export { ForwardRef as ReactComponent };